import { styled } from '@mui/material/styles'

const FieldErrorList = styled('ul')(({ theme }) => ({
  paddingLeft: 4,
  marginTop: 2,
  marginBottom: 0,
  ' > li': {
    listStyleType: 'none',
    color: theme.palette.error.main,
    fontSize: 14
  }
}))

export default FieldErrorList
